<template>
  <WideFooter/>
</template>

<script>
export default {
    name: "Footer",

    components: {
        WideFooter: () => import('../components/footer/WideFooter'),
    },
};
</script>

<style scoped>

</style>
